import * as React from 'react';
import { ETheme } from '../../types';
export const UiKitThemeContext = /*#__PURE__*/React.createContext({
  theme: ETheme.adaptiveLight
});
export function useUiKitThemeContext() {
  return React.useContext(UiKitThemeContext);
}